import { render, staticRenderFns } from "./resultadoDaReposta.vue?vue&type=template&id=0207ef12&"
import script from "./resultadoDaReposta.vue?vue&type=script&lang=js&"
export * from "./resultadoDaReposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports